// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-dialog .yxt-dialog__body,.lc-am-dialog .yxt-dialog__footer{padding:0}.lc-am-dialog-footer{display:block;width:100%;padding:16px 24px;text-align:right}.lc-am-dialog-footer,.lc-am-dialog-footer .lc-am-container{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
